import type { User } from '../types';
import { isValidColombianMobile } from './whatsapp';

export function profileContactComplete(user?: Partial<User> | null): boolean {
  if (user?.is_admin) return true;
  return Boolean(user && user.delivery_address?.trim() && user.delivery_city?.trim() && isValidColombianMobile((user.whatsapp || '').replace(/^57(?=3)/, '')));
}

export function profileContactRequired(user?: Partial<User> | null): boolean {
  return !profileContactComplete(user);
}

const PROFILE_COMPLETION_PATHS = ['/checkout', '/profile', '/welcome'];

export function profileCompletionRequiredForPath(pathname: string): boolean {
  return PROFILE_COMPLETION_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

const PROFILE_NEXT_KEY = 'tc_profile_next';

export function storeProfileNext(next: string): void {
  if (next?.startsWith('/') && !next.startsWith('//')) {
    try { sessionStorage.setItem(PROFILE_NEXT_KEY, next); } catch { /* storage unavailable */ }
  }
}

export function takeProfileNext(fallback = '/'): string {
  try {
    const stored = sessionStorage.getItem(PROFILE_NEXT_KEY);
    sessionStorage.removeItem(PROFILE_NEXT_KEY);
    if (stored?.startsWith('/') && !stored.startsWith('//')) return stored;
  } catch { /* storage unavailable */ }
  return fallback;
}
